module.exports = __webpack_public_path__ + "assets/img/yutari-photo01.0eb6458b.jpg";